"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFailed = exports.isSucceeded = exports.isFulfilled = exports.isPending = exports.isUninitialized = void 0;

var RequestState = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/RequestState"));

var isUninitialized = function isUninitialized(requestState) {
  return requestState === RequestState.UNINITIALIZED;
};

exports.isUninitialized = isUninitialized;

var isPending = function isPending(requestState) {
  return requestState === RequestState.PENDING;
};

exports.isPending = isPending;

var isFulfilled = function isFulfilled(requestState) {
  return requestState === RequestState.SUCCEEDED || requestState === RequestState.FAILED;
};

exports.isFulfilled = isFulfilled;

var isSucceeded = function isSucceeded(requestState) {
  return requestState === RequestState.SUCCEEDED;
};

exports.isSucceeded = isSucceeded;

var isFailed = function isFailed(requestState) {
  return requestState === RequestState.FAILED;
};

exports.isFailed = isFailed;


//////////////////
// WEBPACK FOOTER
// ./js/utils/requestState.js
// module id = 92
// module chunks = 209 210 211 212